import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../../store'
import { useList } from '../../../Contexts/ListContext'
import SuggestionsItem from './Suggestions/SuggestionsItem'
import type { Filter } from '../../../../models/filterTypes'

interface Suggestion {
  title: string
  value: {
    filter: Filter
    results?: number | string
  }
}

interface SuggestionsProps {
  className?: string
  suggestions: Suggestion[]
}

const Suggestions = ({ className, suggestions }: SuggestionsProps): JSX.Element => {
  const dispatch = useDispatch()
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const { setSuggestedFilter } = useList()

  const handleClick = (value: Filter): void => {
    setSuggestedFilter(value)
    dispatch(storeActions.directline.sendMessage({ value: { filters: [value] } }))
  }

  return (
    <div className={`rf-flex rf-flex-col rf-items-start ${className}`}>
      {/* Title */}
      <div className='rf-text-3xl large:rf-text-5xl rf-font-bold rf-mb-5'>{translation.template.suggestiontitle}</div>
      {/* Research suggestions */}
      <div className='rf-flex rf-flex-row rf-flex-wrap'>
        {suggestions.map((suggestion, key) => {
          return (
            <SuggestionsItem
              key={key}
              title={suggestion.title}
              value={suggestion.value.filter}
              results={suggestion.value.results !== undefined ? suggestion.value.results : 'NC'}
              handleClick={handleClick}
            />
          )
        })}
      </div>
    </div>
  )
}

export default Suggestions
